import React from "react";
import { Check, Sparkles, Crown, Gift } from "lucide-react";
import { Button } from "./ui/button";
import { useLang } from "../i18n/LangContext";

const items = [
  { id: "free", icon: Gift, price: 0, oldPrice: 50, popular: false },
  { id: "expert", icon: Sparkles, price: 100, popular: true },
  { id: "alina", icon: Crown, price: 500, popular: false }
];

const Consultations = ({ onOpenForm }) => {
  const { t } = useLang();
  return (
    <section id="consultations" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="eyebrow mb-3">{t("consult.kicker")}</div>
          <h2 className="headline-huge text-3xl md:text-5xl text-balance">{t("consult.title")}</h2>
          <p className="text-slate-600 mt-4">{t("consult.subtitle")}</p>
        </div>
        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {items.map((c) => {
            const Icon = c.icon;
            const data = t(`consult.items.${c.id}`);
            const isPopular = c.popular;
            return (
              <div key={c.id} className={`relative rounded-3xl p-7 card-hover ${isPopular ? 'text-white shadow-2xl' : ''}`} style={isPopular ? { background: '#1B2A4A', border: '1px solid rgba(201,169,110,0.35)' } : { background: '#fbf6ed', border: '1px solid rgba(201,169,110,0.25)' }}>
                {isPopular && (<div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full text-xs font-bold" style={{ background: 'linear-gradient(90deg, #D9BA8A, #C9A96E)', color: '#1B2A4A' }}>{data.badge}</div>)}
                {!isPopular && (<div className={`inline-block px-3 py-1 rounded-full text-xs font-bold mb-4 ${c.id==='free' ? 'bg-emerald-100 text-emerald-700' : ''}`} style={c.id!=='free' ? { background: '#1B2A4A', color: '#C9A96E' } : {}}>{data.badge}</div>)}
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5`} style={isPopular ? { background: '#C9A96E', color: '#1B2A4A' } : { background: '#ffffff', color: '#A88D54', border: '1px solid rgba(201,169,110,0.3)' }}><Icon className="w-6 h-6" /></div>
                <h3 className={`font-display text-2xl uppercase leading-tight ${isPopular ? 'text-white' : ''}`} style={!isPopular ? { color: '#1B2A4A' } : {}}>{data.title}</h3>
                <p className={`mt-3 text-sm ${isPopular ? 'text-white/70' : 'text-slate-600'}`}>{data.desc}</p>
                <div className="mt-6 flex items-baseline gap-2">
                  <span className={`font-display text-5xl`} style={isPopular ? { color: '#C9A96E' } : { color: '#1B2A4A' }}>{c.price === 0 ? '0€' : `€${c.price}`}</span>
                  {c.oldPrice && <span className={`text-sm line-through ${isPopular ? 'text-white/50' : 'text-slate-400'}`}>€{c.oldPrice}</span>}
                  <span className={`ml-auto text-xs ${isPopular ? 'text-white/60' : 'text-slate-500'}`}>{data.duration}</span>
                </div>
                <ul className="mt-6 space-y-2.5">
                  {data.features.map((f, i) => (<li key={i} className={`flex items-start gap-2 text-sm ${isPopular ? 'text-white/85' : 'text-slate-700'}`}><Check className="w-4 h-4 mt-0.5" style={{ color: isPopular ? '#C9A96E' : '#A88D54' }} /> {f}</li>))}
                </ul>
                <Button onClick={onOpenForm} className={`mt-7 w-full h-12 rounded-xl font-semibold ${isPopular ? 'btn-amber' : 'btn-dark'}`}>{t("cta.leaveRequest")}</Button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Consultations;
